import i18n from 'i18next';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

const getErrorMessages = (errorData) => {
  if (errorData && typeof errorData === 'string') return [errorData];

  if (errorData && errorData.errors) {
    return Object.values(errorData.errors).reduce((errors, error) => errors.concat(error), []);
  }

  if (errorData && errorData.BadRequest) {
    return errorData.BadRequest;
  }

  if (errorData && errorData.Conflict) {
    return errorData.Conflict;
  }

  return [i18n.t('common.message.error.global')];
};

const useAgent = (agent, overrideError = false) => {
  const [result, setResult] = useState({ value: undefined, isPending: false });
  const history = useHistory();

  const dispatchError = useCallback(
    (error) => {
      if (!overrideError) {
        if (error && error.response && error.response.status === 404) {
          history.push('/404');
        } else if (error && error.response && error.response.data) {
          const errorMessages = getErrorMessages(error.response.data);
          errorMessages.forEach((errorMessage) => toast.error(errorMessage));
        } else {
          toast.error(i18n.t('common.message.error.global'));
          history.push('/errors/api');
        }
      }
    },
    [overrideError, history]
  );

  const call = useCallback(
    async (...params) => {
      setResult((oldState) => ({ ...oldState, isPending: true }));

      try {
        const response = await agent(...params);
        const data = response && 'data' in response ? response.data : response;
        if (data && data.status === 'forbidden') history.push('/404');
        setResult({ value: data || {}, isPending: false });
      } catch (error) {
        dispatchError(error);
        setResult({ isPending: false });
      }
    },
    [agent, dispatchError, history]
  );

  return [call, result.value, result.isPending];
};

export default useAgent;
